var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "posters-nav-component", class: _vm.className },
    [
      _c("h6", [
        _vm._v("\n        Subtitles  \n        "),
        _c("i", {
          staticClass: "fa fa-plus small",
          on: {
            click: function($event) {
              return _vm.add_video_subs()
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.subtitles, function(subtitle) {
        return _c(
          "div",
          [_c("upload-subtitle", { attrs: { subtitle: subtitle } })],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }